// modules are defined as an array
// [ module function, map of requires ]
//
// map of requires is short require name -> numeric require
//
// anything defined in a previous bundle is accessed via the
// orig method which is the require for previous bundles

(function (
  modules,
  entry,
  mainEntry,
  parcelRequireName,
  externals,
  distDir,
  publicUrl,
  devServer
) {
  /* eslint-disable no-undef */
  var globalObject =
    typeof globalThis !== 'undefined'
      ? globalThis
      : typeof self !== 'undefined'
      ? self
      : typeof window !== 'undefined'
      ? window
      : typeof global !== 'undefined'
      ? global
      : {};
  /* eslint-enable no-undef */

  // Save the require from previous bundle to this closure if any
  var previousRequire =
    typeof globalObject[parcelRequireName] === 'function' &&
    globalObject[parcelRequireName];

  var importMap = previousRequire.i || {};
  var cache = previousRequire.cache || {};
  // Do not use `require` to prevent Webpack from trying to bundle this call
  var nodeRequire =
    typeof module !== 'undefined' &&
    typeof module.require === 'function' &&
    module.require.bind(module);

  function newRequire(name, jumped) {
    if (!cache[name]) {
      if (!modules[name]) {
        if (externals[name]) {
          return externals[name];
        }
        // if we cannot find the module within our internal map or
        // cache jump to the current global require ie. the last bundle
        // that was added to the page.
        var currentRequire =
          typeof globalObject[parcelRequireName] === 'function' &&
          globalObject[parcelRequireName];
        if (!jumped && currentRequire) {
          return currentRequire(name, true);
        }

        // If there are other bundles on this page the require from the
        // previous one is saved to 'previousRequire'. Repeat this as
        // many times as there are bundles until the module is found or
        // we exhaust the require chain.
        if (previousRequire) {
          return previousRequire(name, true);
        }

        // Try the node require function if it exists.
        if (nodeRequire && typeof name === 'string') {
          return nodeRequire(name);
        }

        var err = new Error("Cannot find module '" + name + "'");
        err.code = 'MODULE_NOT_FOUND';
        throw err;
      }

      localRequire.resolve = resolve;
      localRequire.cache = {};

      var module = (cache[name] = new newRequire.Module(name));

      modules[name][0].call(
        module.exports,
        localRequire,
        module,
        module.exports,
        globalObject
      );
    }

    return cache[name].exports;

    function localRequire(x) {
      var res = localRequire.resolve(x);
      if (res === false) {
        return {};
      }
      // Synthesize a module to follow re-exports.
      if (Array.isArray(res)) {
        var m = {__esModule: true};
        res.forEach(function (v) {
          var key = v[0];
          var id = v[1];
          var exp = v[2] || v[0];
          var x = newRequire(id);
          if (key === '*') {
            Object.keys(x).forEach(function (key) {
              if (
                key === 'default' ||
                key === '__esModule' ||
                Object.prototype.hasOwnProperty.call(m, key)
              ) {
                return;
              }

              Object.defineProperty(m, key, {
                enumerable: true,
                get: function () {
                  return x[key];
                },
              });
            });
          } else if (exp === '*') {
            Object.defineProperty(m, key, {
              enumerable: true,
              value: x,
            });
          } else {
            Object.defineProperty(m, key, {
              enumerable: true,
              get: function () {
                if (exp === 'default') {
                  return x.__esModule ? x.default : x;
                }
                return x[exp];
              },
            });
          }
        });
        return m;
      }
      return newRequire(res);
    }

    function resolve(x) {
      var id = modules[name][1][x];
      return id != null ? id : x;
    }
  }

  function Module(moduleName) {
    this.id = moduleName;
    this.bundle = newRequire;
    this.require = nodeRequire;
    this.exports = {};
  }

  newRequire.isParcelRequire = true;
  newRequire.Module = Module;
  newRequire.modules = modules;
  newRequire.cache = cache;
  newRequire.parent = previousRequire;
  newRequire.distDir = distDir;
  newRequire.publicUrl = publicUrl;
  newRequire.devServer = devServer;
  newRequire.i = importMap;
  newRequire.register = function (id, exports) {
    modules[id] = [
      function (require, module) {
        module.exports = exports;
      },
      {},
    ];
  };

  // Only insert newRequire.load when it is actually used.
  // The code in this file is linted against ES5, so dynamic import is not allowed.
  // INSERT_LOAD_HERE

  Object.defineProperty(newRequire, 'root', {
    get: function () {
      return globalObject[parcelRequireName];
    },
  });

  globalObject[parcelRequireName] = newRequire;

  for (var i = 0; i < entry.length; i++) {
    newRequire(entry[i]);
  }

  if (mainEntry) {
    // Expose entry point to Node, AMD or browser globals
    // Based on https://github.com/ForbesLindesay/umd/blob/master/template.js
    var mainExports = newRequire(mainEntry);

    // CommonJS
    if (typeof exports === 'object' && typeof module !== 'undefined') {
      module.exports = mainExports;

      // RequireJS
    } else if (typeof define === 'function' && define.amd) {
      define(function () {
        return mainExports;
      });
    }
  }
})({"cDATH":[function(require,module,exports,__globalThis) {
var _jsxRuntime = require("react/jsx-runtime");
var _client = require("react-dom/client");
var _reactRouterDom = require("react-router-dom");
var _dashboardScss = require("../../css/dashboard.scss");
var _trpc = require("../dashboard/utils/trpc");
var _withNonAuthedTrpcClient = require("../misc/with-non-authed-trpc-client");
var _availabilityPoll = require("./components/availability-poll");
var _timeFinder = require("./components/time_finder");
window.onload = ()=>{
    const container = document.getElementById("time-finder");
    const root = (0, _client.createRoot)(container);
    root.render(/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _withNonAuthedTrpcClient.WithNonAuthedTrpcClient), {
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.BrowserRouter), {
            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(NonDashboardApp, {})
        })
    }));
};
function NonDashboardApp() {
    const history = (0, _reactRouterDom.useHistory)();
    const mutation = (0, _trpc.trpc).time_finder.createPublic.useMutation({
        onSuccess: (data)=>{
            history.push(`/time-finder/view/${data.time_finder_instance_id}`);
        }
    });
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactRouterDom.Switch), {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Route), {
                exact: true,
                path: "/time-finder",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _timeFinder.AppTimeFinder), {
                    is_loading: mutation.isLoading,
                    onSubmit: mutation.mutate,
                    is_public: true,
                    is_on_dashboard: false,
                    does_have_premium: false
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Route), {
                path: "/time-finder/view/:timeFinderID",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _availabilityPoll.PublicAvailabilityPoll), {})
            })
        ]
    });
}

},{"react/jsx-runtime":"dpQXr","react-dom/client":"i3gF3","react-router-dom":[["BrowserRouter","3XSn5"],["Route","djWTS"],["Switch","djWTS"],["useHistory","djWTS"]],"../../css/dashboard.scss":"bI26A","../dashboard/utils/trpc":"dyYvM","../misc/with-non-authed-trpc-client":"c0i33","./components/availability-poll":"b5ZPA","./components/time_finder":"h3qmW"}],"bI26A":[function() {},{}],"c0i33":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "WithNonAuthedTrpcClient", ()=>WithNonAuthedTrpcClient);
var _jsxRuntime = require("react/jsx-runtime");
var _reactQuery = require("@tanstack/react-query");
var _trpc = require("../dashboard/utils/trpc");
var _client = require("@trpc/client");
var _react = require("react");
function WithNonAuthedTrpcClient(props) {
    const [queryClient] = (0, _react.useState)(()=>new (0, _reactQuery.QueryClient)());
    const [trpcClient] = (0, _react.useState)(()=>(0, _trpc.trpc).createClient({
            links: [
                (0, _client.httpBatchLink)({
                    url: "/trpc"
                })
            ]
        }));
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _trpc.trpc).Provider, {
        client: trpcClient,
        queryClient: queryClient,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactQuery.QueryClientProvider), {
            client: queryClient,
            children: props.children
        })
    });
}

},{"react/jsx-runtime":"dpQXr","@tanstack/react-query":[["QueryClient","jC0Ps"],["QueryClientProvider","dHYz4"]],"../dashboard/utils/trpc":"dyYvM","@trpc/client":"98Zm4","react":"IMRgT","@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}]},["cDATH"], "cDATH", "parcelRequire7ff5", {})

//# sourceMappingURL=time-finder.fc77be43.js.map
